module.exports = require('./browser/algorithms.json')



//////////////////
// WEBPACK FOOTER
// ../~/browserify-sign/algos.js
// module id = 379
// module chunks = 0